import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../../../@types/RootState';
import { ContextMenuItem } from '../../../../../../components';
import { AlertWithTimestamp } from '../../../../../../components/AlertWithTimestamp';
import { selectorContextMenu } from '../../../../../../reducers/gerenciadorPrecos/contextMenu';
import { RuleCompositionData, SET_DATA, SET_IS_OPEN } from '../../../../../../reducers/ipa/priceManager/modals/ruleComposition';
import { getCompositionRule } from '../../../../RegrasPreco/Cadastro/services';

type RuleCompositionContextMenuProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const RuleCompositionContextMenu = ({ contextMenuDatapoint: { ruleId, productsToBePricedId }, setData, openModal }: RuleCompositionContextMenuProps) => {
  const handleOpenCompositionRuleModal = useCallback(async () => {
    try {
      const response: RuleCompositionData = await getCompositionRule(ruleId, productsToBePricedId);
      if (!response) throw new Error('Erro ao carregar composição de regra');
      setData(response);
      openModal();
    } catch (err) {
      throw AlertWithTimestamp({ message: err.message });
    }
  }, [ruleId, productsToBePricedId]);

  if (!ruleId) return null;

  return <ContextMenuItem onClick={handleOpenCompositionRuleModal}>Regra preço regular</ContextMenuItem>;
};

const mapStateToProps = (state: RootState) => ({
  contextMenuDatapoint: selectorContextMenu(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setData: (payload: RuleCompositionData) => dispatch(SET_DATA(payload)),
  openModal: () => dispatch(SET_IS_OPEN()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RuleCompositionContextMenu);
